import React, {Fragment, PureComponent} from 'react';
import PropTypes from 'prop-types';

import ContactDetailForm from '../../../components/Forms/ContactDetailForm/ContactDetailForm.jsx';
import SubmitButton from '../../../components/Forms/ContactDetailForm/SubmitButton.jsx';

import './ContactDetail.scss';

export default class ContactDetail extends PureComponent {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    submit: PropTypes.func.isRequired,
  };

  render() {
    return <Fragment>
      <h2 className="text-center">Informations de contact</h2>
      <ContactDetailForm initialValues={this.props.currentUser} onSubmit={this.props.submit}/>
      <div className="text-center">
        <SubmitButton className="btn btn-primary">Suivant</SubmitButton>
      </div>
    </Fragment>;
  }
}
